import { Component, type ErrorInfo, type ReactNode } from 'react'
import i18n from '@/lib/i18n'

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('App error:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-md bg-bg p-lg text-center">
          {/* Class component — use i18n.t directly (no hooks). */}
          <h1 className="text-h3 font-bold text-text">{i18n.t('common.error', 'Something went wrong')}</h1>
          <p className="max-w-sm text-body text-text-secondary">
            {i18n.t('webapp.log.error', 'Something went wrong. Please try again.')}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-lg bg-primary px-md py-sm text-button font-semibold text-white hover:opacity-90"
          >
            {i18n.t('common.retry', 'Retry')}
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
